import {
    Component,
    OnInit,
    ViewEncapsulation,
    Directive,
    HostListener,
    ViewChild,
    ElementRef,
    ChangeDetectorRef,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { FuseConfigService } from "@fuse/services/config.service";
import { fuseAnimations } from "@fuse/animations";
import { AuthenticationService } from "../../common/service/authentication.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { TeamService } from "../../sterilwize/team/team.service";
// import { NgxSpinnerService } from 'ngx-spinner';
import { Globals } from "../../common/global";
import { ConfigService } from "../../common/config/config.service";
import { CookieService } from "ngx-cookie-service";
import { StorageService } from "app/main/module/common/service/storage.service";
import { ApiService } from "../../common/service/api.service";
import {
    allTrue,
    resourceCenter,
    techTrue,
} from "../../../../navigation/navigationItemObjects";
import { hasOwnProperty } from "tslint/lib/utils";
// import {getLabCenterList} from '../../../../../../functions/src/api/center/centerList';
import { TokenStorageService } from "../../common/service/token-storage.service";
import { Session } from "protractor";
import { TranslateService } from "@ngx-translate/core";
import { FuseNavigationService } from "@fuse/components/navigation/navigation.service";
import { navigation } from "app/navigation/navigation";
import { forkJoin, of } from "rxjs";
import { AppStateService } from "../../common/service/appstate.service";
import { ReminderService } from "../../sterilwize/Cases/reminder/reminder-popup/reminder-popup.service";
import { UserContextService } from "../../common/service/user-context.service";

@Component({
    selector: "login-2",
    templateUrl: "./login.component.html",
    styleUrls: ["./login.component.scss"],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
})
export class LoginComponent implements OnInit {
    loginForm: FormGroup;
    isShowProgress = false;
    email = "";
    infoMsg = "";
    msgColor = "";
    color = ["green", "red", "blue"];
    spinner = false;
    userData: any;
    credentialData: any;
    landingPage: string = "";
    navigationData: any;
    navigationType: any;
    isLoginFailed: boolean;
    roles: any;
    isLoggedIn: boolean;
    currentUser: any;
    errorMessage: any;
    labsDataId: Array<any> = [];
    userInfo: Array<any> = [];
    labsDetail: any;
    role: any;
    allConfigurationByrole: any;
    currentRoleData: any;
    can_see_twostepcheckout_screen: any;
    can_edit_resource_files: any;
    can_delete_resource_files: any;
    center: string = "";

    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     * @param {FormBuilder} _formBuilder
     */
    //
    @HostListener("contextmenu", ["$event"])
    onRightClick(event) {
        event.preventDefault();
    }

    constructor(
        private _fuseConfigService: FuseConfigService,
        private authService: AuthenticationService,
        public snackBar: MatSnackBar,
        private _formBuilder: FormBuilder,
        private router: Router,
        public teamService: TeamService,
        // private ngxSpinnerService: NgxSpinnerService,
        private globals: Globals,
        private configService: ConfigService,
        private cookieService: CookieService,
        private userService: StorageService,
        private apiService: ApiService,
        public tokenStorage: TokenStorageService,
        private translate: TranslateService,
        private _fuseNavigationService: FuseNavigationService,
        private _changeDetectorRef: ChangeDetectorRef,
        public appState: AppStateService,
        public reminderService: ReminderService,
        public userContextService: UserContextService
    ) {
        // Configure the layout
        this._fuseConfigService.config = {
            layout: {
                navbar: {
                    hidden: true,
                },
                toolbar: {
                    hidden: true,
                },
                footer: {
                    hidden: true,
                },
                sidepanel: {
                    hidden: true,
                },
            },
        };
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        this.loginForm = this._formBuilder.group({
            email: ["", [Validators.required, Validators.email]],
            password: ["", Validators.required],
        });
    }

    login(): void {
        const keep = new Set(["language"]);
        Object.keys(localStorage).forEach((key) => {
            if (!keep.has(key)) {
                // console.log(`Removing key: ${key}`);
                localStorage.removeItem(key);
            }
        });
        this.userService.clearCookie();
        this.spinner = true;
        this.authService.login(this.loginForm.value).subscribe(
            (data) => {
                // console.log(data);

                if (data.data.length == 0) {
                    this.openSnackBar(
                        this.translateSentence("Login.InvalidUsername"),
                        this.translateSentence("Common.close")
                    );
                    return (this.spinner = false);
                } else {
                    this.tokenStorage.saveToken(data.data[0].token);
                }
                this.spinner = true;
                this.tokenStorage.saveUser(data.data[0]);
                this.isLoginFailed = false;
                this.isLoggedIn = true;
                this.currentUser = this.tokenStorage.getUser();
                this.userService.setCookie("token", this.currentUser.token);
                if (this.currentUser) {
                    this.spinner = false;
                    this.checkFetchedUser(this.currentUser);
                    this.userService.setCookie("userId", this.currentUser.id);
                } else {
                    // do something else
                    // // // console.log(");
                }
            },
            (err) => {
                this.errorMessage = this.translateSentence(
                    err.error.message === "Invalid Password!"
                        ? "Login.InvalidPassword"
                        : "Login.InvalidUsername"
                );
                if (err.status != 200) {
                    this.spinner = false;
                    if (
                        this.errorMessage == undefined ||
                        this.errorMessage == "undefined"
                    ) {
                        const message = this.translateSentence(
                            "Login.InvalidCredentials"
                        );
                        this.openSnackBar(
                            message,
                            this.translateSentence("Common.close")
                        );
                    } else {
                        this.openSnackBar(
                            this.errorMessage,
                            this.translateSentence("Common.close")
                        );
                        console.log(`Error: ${this.errorMessage}`);
                    }
                }
                this.isLoginFailed = true;
            }
        );
    }

    logout(): void {
        const keep = new Set(["language"]);
        Object.keys(localStorage).forEach((key) => {
            if (!keep.has(key)) {
                // console.log(`Removing key: ${key}`);

                localStorage.removeItem(key);
            }
        });
        this.userService.clearCookie();
        // this.globals.cassetteConfig = null;
        this.reminderService.clear();
        this.router.navigate(["/login"]);
        // location.reload();
    }

    checkFetchedUser(result) {
        this.email = result.email; // setting session storage value
        // // // console.log(l);
        this.userService.setCookie("email", this.email);

        if (result) {
            if (this.email) this.getuserdata();

            // this.router.navigate(['/'+this.landingPage]);
        } else {
            // // // console.log(');
            this.msgColor = this.color[1];
            this.infoMsg = "User not authorized";
            this.openSnackBar(
                "User not authorized",
                this.translateSentence("Common.close")
            );
        }
    }

    getuserdata() {
        this.spinner = true;

        const token = this.userService.getCookie("token");
        // // // console.log(n);
        const email = this.userService.getCookie("email");

        this.apiService.getAllLabID(token, email).subscribe(
            (a) => {
                // console.log(a);
                Object.entries(a).find(([key, value]) => {
                    // // console.log(e);
                    if (key == "data") {
                        this.labsDataId = value;
                        this.labsDataId.forEach((element) => {
                            localStorage.setItem("labs", element.labs.length);
                            // console.log(element);
                            const allDefaultLabFalse = element.labs.every(
                                (lab) => lab.default_lab === false
                            );
                            if (allDefaultLabFalse) {
                                this.openSnackBar(
                                    this.translate.instant(
                                        "Login.NoLabAssigned"
                                    ),
                                    this.translateSentence("Common.ok")
                                );
                                this.spinner = false;
                            }
                            if (element.labs.length != 0) {
                                element.labs.forEach((userlab) => {
                                    if (userlab.default_lab == true) {
                                        this.appState.setLabId(userlab.lab_id);
                                        // this.userService.setCookie(
                                        //     "center",
                                        //     userlab.center
                                        // );
                                        this.center = userlab.center;
                                        this.userService.setCookie(
                                            "role",
                                            userlab.role
                                        );
                                        this.userContextService.updateName(
                                            element.name
                                        );
                                        this.userContextService.updateProfilePicture(
                                            element.profile_pic
                                        );

                                        const lang = element.preferred_language
                                            ? element.preferred_language
                                            : "en";

                                        localStorage.setItem("language", lang);
                                        this.translate
                                            .use(lang)
                                            .subscribe(() => {
                                                const translatedNav =
                                                    this.translateNavigation([
                                                        ...navigation,
                                                    ]);
                                                this._fuseNavigationService.unregister(
                                                    "navbar"
                                                );
                                                this._fuseNavigationService.register(
                                                    "navbar",
                                                    translatedNav
                                                );
                                                this._fuseNavigationService.setCurrentNavigation(
                                                    "navbar"
                                                );

                                                this._changeDetectorRef.markForCheck();
                                                this._changeDetectorRef.detectChanges();
                                            });

                                        // this.navigationType = 'all';
                                        // // // console.log(e);

                                        // // // console.log(a);)
                                        // this.router.navigate(['/' + this.landingPage]);
                                        this.getTimeZone();
                                    }
                                });
                            } else {
                                this.spinner = false;
                                window.alert(
                                    this.translate.instant(
                                        "Login.NoLabAssigned"
                                    )
                                );
                            }
                        });
                    } else {
                        // // // console.log(e);
                    }
                });
            },

            (err) => {
                this.errorMessage = err.error.message;
                // // console.log(e);
                if (err.status == 401) {
                    alert(this.translate.instant("Login.InvalidToken"));
                    this.logout();
                }
                this.isLoginFailed = true;
            }
        );
    }

    getROleconfiguration(loginUserRole) {
        this.navigationData = "";
        this.navigationType = "";

        this.apiService.getAllRoleByName(loginUserRole).subscribe(
            (a) => {
                Object.entries(a).find(([key, value]) => {
                    if (key == "data") {
                        this.allConfigurationByrole = value;
                        this.allConfigurationByrole.forEach((element) => {
                            this.currentRoleData = element.access_specifier;
                            this.can_edit_resource_files =
                                element.access_specifier
                                    .can_edit_resource_files ?? false;
                            this.can_delete_resource_files =
                                element.access_specifier
                                    .can_delete_resource_files ?? false;
                            for (const [key, value] of Object.entries(
                                this.currentRoleData
                            )) {
                                this.can_see_twostepcheckout_screen =
                                    this.currentRoleData.can_see_twostepcheckout_screen;

                                if (this.role == "doctor") {
                                    this.navigationType = "ot";
                                } else if (
                                    this.can_see_twostepcheckout_screen == true
                                ) {
                                    this.navigationType = "all";
                                } else {
                                    this.navigationType = "usernav";
                                }

                                if (this.role == "technician") {
                                    this.navigationType = "tech";
                                }
                                switch (this.navigationType) {
                                    case "rcenter":
                                        this.navigationData = resourceCenter;
                                        this.landingPage = "rcenter/centers";
                                        break;
                                    case "all":
                                        this.navigationData = allTrue;
                                        this.landingPage = "dashboard";
                                        break;
                                    // case 'usernav':
                                    //     this.navigationData = userTrue;
                                    //     this.landingPage = 'dashboard';
                                    //     break;
                                    // case 'ot':
                                    //     this.navigationData = ot;
                                    //     this.landingPage = '/cassette/patientcheckoutList';
                                    //  break;
                                    case "tech":
                                        this.navigationData = techTrue;
                                        this.landingPage =
                                            "/tickets/tickets-list";
                                        break;
                                    default:
                                        this.navigationData = allTrue;
                                        this.landingPage = "dashboard";
                                }

                                // // console.log(e);
                                this.userService.setCookie(
                                    "navigationType",
                                    this.navigationType
                                );
                                this.userService.setCookie(
                                    "pageDynamicConfig",
                                    JSON.stringify(this.navigationData)
                                );

                                this.userService.setCookie(
                                    "can_edit_resource_files",
                                    this.can_edit_resource_files
                                );
                                this.userService.setCookie(
                                    "can_delete_resource_files",
                                    this.can_delete_resource_files
                                );

                                this.router.navigate(["/" + this.landingPage]);
                            }
                        });

                        // // // console.log(e);
                    } else {
                    }
                });
            },

            (err) => {
                this.errorMessage = err.error.message;
                // // console.log(e);
                if (err.status == 401) {
                    // // // console.log(");,
                    alert(this.translate.instant("Login.InvalidToken"));
                    this.logout();
                }
            }
        );
    }

    getTimeZone() {
        // // console.log(");
        const token = this.userService.getCookie("token");
        const labId = this.userService.getCookie("lab_id");
        this.apiService.getLabIdDetail(token, labId).subscribe(
            (a) => {
                // console.log(a);
                Object.entries(a).find(([key, value]) => {
                    if (key == "data") {
                        this.labsDetail = value;
                        const faqDataArr = this.labsDetail[0]?.faqs;
                        const faqIds = faqDataArr.map((item) => item.faq_id);
                        localStorage.setItem("faqIds", JSON.stringify(faqIds));
                        const pmsIntegration =
                            this.labsDetail[0].pms_integration ?? false;
                        const patientForceUpdate =
                            this.labsDetail[0].patient_force_update ?? false;
                        const enable_ticketing_support =
                            this.labsDetail[0].enable_ticketing_support ??
                            false;
                        const isMultiCenter =
                            this.labsDetail[0]?.multi_center ?? false;
                        const centerList = this.labsDetail[0]?.centers ?? [];

                        let finalCenter = "";

                        if (isMultiCenter) {
                            if (this.center && this.center.trim() !== "") {
                                finalCenter = this.center;
                            } else if (centerList?.length) {
                                finalCenter = centerList[0]?.id;
                            }
                        }

                        this.userService.setCookie("center", finalCenter);

                        localStorage.setItem(
                            "pms_integration",
                            JSON.stringify(pmsIntegration)
                        );
                        localStorage.setItem(
                            "patient_force_update",
                            JSON.stringify(patientForceUpdate)
                        );
                        localStorage.setItem(
                            "enable_ticketing_support",
                            enable_ticketing_support
                        );
                        this.labsDetail.forEach((element) => {
                            // // // console.log(e);
                            this.userService.setCookie(
                                "defaultTz",
                                element.default_time_zone
                            );
                            this.userService.setCookie(
                                "lab_name",
                                element.lab_name
                            );
                            this.userService.setCookie(
                                "lab_logo",
                                element.lab_logo
                            );
                            this.userService.setCookie(
                                "multi_center",
                                element.multi_center
                            );
                            localStorage.setItem(
                                "reminder_interval",
                                element.reminder_interval
                            );

                            localStorage.setItem(
                                "lab_cases_list",
                                JSON.stringify(element.lab_cases)
                            );
                            // localStorage.setItem("show_lab_cases",element.show_lab_cases)
                            this.appState.setShowLabCases(
                                element.show_lab_cases
                            );
                            this.role = localStorage.getItem("role");
                            //    // // console.log(e);
                            this.getROleconfiguration(this.role);
                            this.getCassetteConfig();
                            // this.getEmailFromLabConfig();
                        });

                        // });
                    } else {
                        // // // console.log(e);
                    }
                });
            },

            (err) => {
                this.errorMessage = err.error.message;
                // // console.log(e);
                if (err.status == 401) {
                    // // // console.log(");,
                    alert(this.translate.instant("Login.InvalidToken"));
                    this.logout();
                }
                this.isLoginFailed = true;
            }
        );
    }

    getCassetteConfig() {
        this.apiService.getCassetteconfigdata().subscribe((a) => {
            // console.log("Cassette config: ", a);
            Object.entries(a).find(([key, value]) => {
                if (key == "data") {
                    localStorage.setItem(
                        "equipments",
                        JSON.stringify(value[0]?.equipments)
                    );
                    value.forEach((element) => {
                        localStorage.setItem(
                            "can_assign_if_incubator_pending",
                            element.cassette.can_assign_if_incubator_pending
                        );
                        localStorage.setItem(
                            "hide_result_pending_confirmation",
                            element.cassette.hide_result_pending_confirmation
                        );
                        localStorage.setItem(
                            "verify_indicator_on_checkout",
                            element.cassette.verify_indicator_on_checkout
                        );
                        // // console.log(g);
                        Object.entries(element.cassette).find(
                            ([key, value]) => {}
                        );
                    });
                }
            });
        });
    }

    // getEmailFromLabConfig() {
    //     this.apiService.getLabconfigdata().subscribe((config) => {
    //         console.log(config);
    //         Object.entries(config).find(([key, value]) => {
    //             // // console.log(e);
    //             if (key == "data") {
    //                 const emailConfig = value;
    //                 // // console.log(s);
    //                 emailConfig.forEach((element) => {
    //                     localStorage.setItem(
    //                         "checkout_email",
    //                         JSON.stringify(element.email.checkout_email)
    //                     );
    //                     localStorage.setItem(
    //                         "enable_lab_checkout_email",
    //                         element.email.enable_lab_checkout_email
    //                     );
    //                     localStorage.setItem(
    //                         "enable_patient_checkout_email",
    //                         element.email.enable_patient_checkout_email
    //                     );
    //                     // return this.barcodeList
    //                     // // console.log(t);
    //                 });

    //                 // // console.log(t);
    //             }
    //             // else {
    //             //     // // console.log(e);
    //             // }
    //         });
    //     });
    // }

    openSnackBar(message: string, action: string): void {
        this.snackBar.open(message, action, {
            duration: 3000,
        });
    }

    translateSentence(key: string, params?: any): string {
        return this.translate.instant(key, params);
    }

    private translateNavigation(items: any[]): any[] {
        return items.map((item) => {
            const newItem = { ...item };
            if (newItem.translate) {
                newItem.title = this.translate.instant(newItem.translate);
            }
            if (newItem.children) {
                newItem.children = this.translateNavigation(newItem.children);
            }
            return newItem;
        });
    }
}
